import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "pencil"
const PencilIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path
            fillRule="evenodd"
            d="M16.94 2.25C17.525 1.664 18.475 1.664 19.06 2.25L21.75 4.94C22.336 5.525 22.336 6.475 21.75 7.06L8.56 20.25H21.75V21.75H3C2.586 21.75 2.25 21.414 2.25 21V16.94zM3.75 17.56V20.25H6.44L17.313 9.375 14.625 6.685zM15.686 5.626 18.374 8.315 20.689 6 18 3.31z"
            clipRule="evenodd"
          />
        </svg>
      }
    </span>
  )
}
export default PencilIcon
